import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PriceSettingEnum } from '@infrastructure/price-setting.enum';
import { PriceItem, PriceResponse } from '@models/price-model';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '@services/language.service';
import { AppState } from '@shared/app-state';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
	selector: 'app-get-price',
	templateUrl: './get-price.component.html',
	styleUrls: ['./get-price.component.scss'],
	imports: [CommonModule, TranslatePipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true
})
export class GetPriceComponent implements OnInit, OnDestroy {

	@Input() priceResponse: BehaviorSubject<PriceResponse | null> = new BehaviorSubject<PriceResponse | null>(null);

	@Output() public getPriceEmitter: EventEmitter<void> = new EventEmitter();

	public isDoingPriceQuery: boolean = false;
	public fetchedPrice: PriceItem | null = null;
	private subscriptions: Array<Subscription> = [];
	public priceSetting: typeof PriceSettingEnum = PriceSettingEnum;
	currentLanguage: string

	constructor(private languageService: LanguageService, public appState: AppState) { }

	ngOnInit(): void {
		this.currentLanguage = this.languageService.currentLanguage

		this.subscriptions.push(this.priceResponse.subscribe(async price => {
			if (price) {
				if (price.data) {
					this.fetchedPrice = price.data.responseItems[0];
				}
				else {
					this.fetchedPrice = new PriceItem();
					this.fetchedPrice.priceFound = false;
					this.fetchedPrice.status = price.status;
				}

				setTimeout(() => {
					this.isDoingPriceQuery = false;
				}, 1000);
			}
		}));

		this.subscriptions.push(this.appState.priceSetting.subscribe(async priceSetting => {
			if (priceSetting.PriceSetting === PriceSettingEnum.AllowNone) {
				await this.reset();
			}
		}),
			this.appState.priceWasPossiblyInfluenced.subscribe(async () => {
				await this.reset();
			})
		);
	}

	ngOnDestroy() {
		this.subscriptions.forEach(x => x.unsubscribe());
	}

	public async getPrice() {
		this.isDoingPriceQuery = true;

		this.getPriceEmitter.emit();
	}

	public async reset() {
		this.fetchedPrice = null;
		this.isDoingPriceQuery = false;
	}

}
